var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1392 7.24062C35.5253 6.85451 35.5303 6.23009 35.1504 5.83786L30.2891 0.818026C29.9012 0.417473 29.2606 0.411548 28.8654 0.804859L18.7796 10.8412C18.3888 11.2301 17.757 11.2293 17.3671 10.8395L7.32462 0.796951C6.9341 0.406427 6.30093 0.406426 5.91041 0.796951L0.873177 5.83418C0.481299 6.22606 0.482856 6.8619 0.876649 7.25185L11.0128 17.2892C11.408 17.6805 11.408 18.319 11.0128 18.7103L0.876693 28.7476C0.482883 29.1376 0.481346 29.7735 0.873265 30.1653L5.91121 35.2027C6.30174 35.5931 6.93488 35.5931 7.32538 35.2026L17.3679 25.16C17.7578 24.7702 18.3896 24.7694 18.7804 25.1583L28.8662 35.1947C29.2614 35.588 29.902 35.5821 30.2899 35.1815L35.1512 30.1617C35.5311 29.7694 35.5261 29.145 35.14 28.7589L25.0879 18.7068C24.6974 18.3163 24.6974 17.6832 25.0879 17.2927L35.1392 7.24062Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.93a2709c74f78726519298e08b4ffcfc.svg";
export { ForwardRef as ReactComponent };